import { RedoFulfillmentToteSchema } from "@redotech/redo-fulfillment-group-common/fulfillment-tote";
import { locationIdFormat } from "@redotech/redo-inventory-id";
import { RedoFulfillmentToteGroupSchema } from "@redotech/redo-model/fulfillments/fulfillment-tote-group";
import * as z from "zod";

export const getTotes = {
  name: "getTotes" as const,
  input: z.object({ locationId: locationIdFormat.schema.nullish() }),
  output: z.object({
    totes: z.array(RedoFulfillmentToteSchema),
    toteGroups: z.array(RedoFulfillmentToteGroupSchema),
  }),
};

export type GetTotesInput = z.infer<typeof getTotes.input>;
